import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13dfb6ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13dfb6ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dfb6ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13dfb6ea')) {
      api.createRecord('13dfb6ea', component.options)
    } else {
      api.reload('13dfb6ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13dfb6ea&scoped=true", function () {
      api.rerender('13dfb6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/draw/activity/index.vue"
export default component.exports